import { useEffect, useState } from 'react'
import { pushNavColor } from './uiConfig'

// Global nav-bar background colour, experimented with from the QA page. One
// value, per-workstation (localStorage), live-synced like the product name.
// The top header AND the floating chat circle read it.

const KEY = 'me_nav_color'
const EVT = 'me-nav-color-change'
export const DEFAULT_NAV_COLOR = '#E8E4DD'

// Two rows of 8 for the QA swatch picker: (a) earthy tones including the
// current default; (b) '80s neon sharpie brights.
export const NAV_COLOR_OPTIONS: { earthy: string[]; neon: string[] } = {
  earthy: ['#FFFFFF', '#E8E4DD', '#DBCFBA', '#C7B299', '#A9B29A', '#9E8B6C', '#B07B57', '#7C7A63', '#5E4B3A'],
  neon:   ['#FF5F5B', '#FF9E1B', '#FFE93B', '#5CFF3B', '#00E5FF', '#3B7BFF', '#B44CFF', '#FF3BAE'],
}

export function loadNavColor(): string {
  try {
    const v = localStorage.getItem(KEY)
    return v && /^#[0-9a-fA-F]{6}$/.test(v) ? v : DEFAULT_NAV_COLOR
  } catch {
    return DEFAULT_NAV_COLOR
  }
}

export function saveNavColor(c: string): void {
  try { localStorage.setItem(KEY, c) } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent(EVT))
  // Publish to the tenant's server-side config (debounced; no-ops for
  // non-writers / before sync init).
  pushNavColor(c)
}

// Apply the tenant's server-side nav colour into this browser (server wins).
// Writes the cache + fires the live event; does NOT push back. Called once on
// app load from App.tsx.
export function applyServerNavColor(raw: unknown): void {
  if (typeof raw !== 'string' || !/^#[0-9a-fA-F]{6}$/.test(raw)) return
  try { localStorage.setItem(KEY, raw) } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent(EVT))
}

export function useNavColor(): string {
  const [c, setC] = useState<string>(loadNavColor)
  useEffect(() => {
    const reload = () => setC(loadNavColor())
    window.addEventListener(EVT, reload)
    window.addEventListener('storage', reload)
    return () => {
      window.removeEventListener(EVT, reload)
      window.removeEventListener('storage', reload)
    }
  }, [])
  return c
}
